import HttpClientManager from '@/business/core/clients/http/helpers/manager.helper';

export type BillingCycle = 'Monthly' | 'Annual' | 'Gift' | 'Custom' | number;

class SubscriptionRepository {
	static #instance: SubscriptionRepository;
	private readonly httpClient: any;
	private readonly base = 'Subscriptions';

	private constructor() {
		this.httpClient = HttpClientManager.getInstance();
	}

	public static getInstance(): SubscriptionRepository {
		if (!SubscriptionRepository.#instance) {
			SubscriptionRepository.#instance = new SubscriptionRepository();
		}
		return SubscriptionRepository.#instance;
	}

	getPlans() {
		return this.httpClient(`${this.base}/Plans`, { method: 'get' });
	}

	getCurrent() {
		return this.httpClient(`${this.base}/Business/Current`, { method: 'get' });
	}

	getPayments(page = 1, size = 20) {
		return this.httpClient(`${this.base}/Business/Payments/Page/${page}/Size/${size}`, { method: 'get' });
	}

	getHistory(page = 1, size = 20) {
		return this.httpClient(`${this.base}/Business/History/Page/${page}/Size/${size}`, { method: 'get' });
	}

	purchaseWithWallet(planCode: string, billingCycle: BillingCycle) {
		return this.httpClient(`${this.base}/Business/Purchase/Wallet`, {
			method: 'post',
			data: { planCode, billingCycle },
			isShowNotify: true,
		});
	}

	purchaseWithGateway(planCode: string, billingCycle: BillingCycle) {
		return this.httpClient(`${this.base}/Business/Purchase/Gateway`, {
			method: 'post',
			data: { planCode, billingCycle },
			isShowNotify: true,
		});
	}

	getAdminPlans() {
		return this.httpClient(`${this.base}/Admin/Plans`, { method: 'get' });
	}

	getAdminDashboard() {
		return this.httpClient(`${this.base}/Admin/Dashboard`, { method: 'get' });
	}

	upsertAdminPlan(plan: object) {
		return this.httpClient(`${this.base}/Admin/Plans`, {
			method: 'put',
			data: plan,
			isShowNotify: true,
		});
	}

	getAdminBusinessSubscriptions(params = {}) {
		return this.httpClient(`${this.base}/Admin/Businesses`, { method: 'get', params });
	}

	getAdminPayments(params = {}) {
		return this.httpClient(`${this.base}/Admin/Payments`, { method: 'get', params });
	}

	changeBusinessSubscription(businessId: string, data: object) {
		return this.httpClient(`${this.base}/Admin/Businesses/${businessId}`, {
			method: 'post',
			data,
			isShowNotify: true,
		});
	}

	createBusinessOverride(businessId: string, data: object) {
		return this.httpClient(`${this.base}/Admin/Businesses/${businessId}/Overrides`, {
			method: 'post',
			data,
			isShowNotify: true,
		});
	}
}

export default SubscriptionRepository;
